export default __webpack_public_path__ + "static/media/icon-phone.34d18c33.svg";